import {
  Box,
  Button,
  Grid,
  makeStyles,
  Popover,
  Typography,
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import React, { useCallback, useEffect, useState } from "react";
import { Bar, Pie, Line } from "react-chartjs-2";
import { useLocation } from "react-router";
import CustomSelect from "../../../../../Components/CustomSelect";
import CustomSelectMulti from "../../../../../Components/CustomSelectMulti";
import DataService from "../../../../../Service";
import chartConstants from "./ChartConstants";
import moment from "moment";
import { DateRange } from "react-date-range";
import ChartLoader from "./ChartLoader";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import SettingsIcon from "@material-ui/icons/Settings";
const options = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
      position: "right",
    },
  },
};
const useStyles = makeStyles((theme) => ({
  datePicker: {},
  datepickerPopover: {
    textAlign: "right",
    "& button": {
      backgroundColor: "#ffffff",
      border: "1px solid #d7dae2",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    },
  },
  pieContainer: {
    width: "48.2%",
    transform: "translate(50%, 0)",
  },
  customTextField: {
    "& div": {
      padding: "0px !important",
      height: "47px",
    },
  },
}));

function Finance(props) {
  props.setLoader(false);
  const { isManageInfo } = props;
  const classes = useStyles();
  const [userData, setUserData] = useState({
    organisation: "",
    client: "",
    quater_type: "",
  });
  const [orgListsArr, setOrgListsArr] = useState([]);
  const [org_attribute, setOrg_attribute] = useState([]);
  const [assignmentStatusChartData, setAssignmentStatusChartData] = useState(
    chartConstants.data
  );
  const [incomeData, setIncomeData] = useState({});
  const [minValStatstics, setMinValStatstics] = useState("");
  const [maxVal, setMaxVal] = useState("");
  const [assignmentPieDurationData, setAssignmentPieDurationData] = useState(
    chartConstants.slaPieGraph
  );
  const [assignmentFinancialStatistics, setAssignmentFinancialStatistics] =
    useState(chartConstants.finLinedata);
  const [anchorElPicker, setAnchorElPicker] = useState(null);
  const [queryParams, setQueryParams] = useState(
    // "from_date=Apr " +
    //   new Date().getFullYear() +
    //   "&end_date=Mar " +
    //   (new Date().getFullYear() + 1)
  );
  const [filterDataState, setFilterDataState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const openPicker = Boolean(anchorElPicker);
  const id = openPicker ? "simple-popover" : undefined;

  const initialState = {
    organisationLoader: true,
    incomeLoader: true,
    financialLoader: true,
    incoiceLoader: true,
    pieLoader: true,
  };
  //new
  const [orgValue, setOrgValue] = useState("");

  const [inputValue, setInputValue] = React.useState("");

  ///
  const [chartLoader, setChartLoader] = useState({ ...initialState });

  const handleClickPicker = (event) => {
    setAnchorElPicker(event.currentTarget);
  };

  const handleClosePicker = () => {
    setAnchorElPicker(null);
  };

  const onChangeItem = (selectedItemValue, inputId, routeFrom) => {
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
    // if (selectedItemValue.id === "organisation") {

    //     const currentOrg = orgListsArr.filter((option) => option.organisation_name == selectedItemValue.value)
    //     groupedCall(currentOrg[0].id, queryParams, queryParams)
    // }
    if (selectedItemValue.id === "quater_type") {
      setChartLoader((prev) => ({ ...prev, pieLoader: true }));
      getAssignmentByPieDuration();
    }
  };

  //new
  const organisationListHandler = (event, newValue) => {
    if (newValue === null) {
      newValue = "";
    }
    console.log(newValue);
    setOrgValue(newValue);
    // setUserData(prev => ({ ...prev, organisation_id: newValue.id }))
    setChartLoader({ ...initialState });
    let params = {}
    if(filterDataState[0]?.startDate && filterDataState[0]?.endDate ){
    params = {
    from_date:  moment(filterDataState[0]?.startDate).format("MMM") + " " + new Date().getFullYear() ,
    end_date :  moment(filterDataState[0]?.endDate).format("MMM") + " " + new Date().getFullYear()
    }}
    groupedCall(newValue.id, params);
  };

  ///

  // const onChangeMultiItem = (obj, inputId, routeFrom) => {
  //     if (inputId == "org_attributes") {
  //         org_attribute.length = 0
  //         setOrg_attribute(org_attribute.concat((obj)))
  //     }
  // }
  // const data = {
  //     maintainAspectRatio: false,
  //     responsive: false,
  //     labels: ["a", "b", "c", "d"],
  //     datasets: [
  //         {
  //             data: [300, 50, 100, 50],
  //             // backgroundColor: chartColors,
  //             // hoverBackgroundColor: chartColors
  //         }
  //     ]
  // };
  const groupedCall = (value, queryParams) => {
    // console.log(value,queryParams,"values")
    getAssignmentInvoiceDate(value, queryParams);
    getIncomeDetail(value, queryParams);
    getAssignmentByPieDuration(value, queryParams);
    getAssignmentByStatatics(value, queryParams);
  };

  useEffect(() => {
    getOrganisationsData();
    groupedCall(null, queryParams);
  }, []);

  useEffect(() => {
    if (filterDataState[0]?.startDate !== filterDataState[0]?.endDate ||
      (filterDataState[0]?.startDate === "" &&
        filterDataState[0]?.endDate === "")) {
      let params = {} 
      console.log(filterDataState,"date filter")
      if(filterDataState[0]?.startDate !== "" ){
        params = {
          from_date:  moment(filterDataState[0]?.startDate).format("MMM") + " " + moment(filterDataState[0]?.startDate).year() ,
          end_date :  moment(filterDataState[0]?.endDate).format("MMM") + " " + moment(filterDataState[0]?.endDate).year()
          }
      }    
      props.setLoader(true);
      groupedCall(
        orgValue.id,
        params
      );
      setAnchorElPicker(null);
    }
  }, [filterDataState]);

  const getOrganisationsData = () => {
    DataService.getData({}, "organisations").then((response) => {
      orgListsArr.length = 0;
      var localArr = [
        {
          id: null,
          org_id: null,
          organisation_name: "All",
          internal_status: "All",
        },
        ...response.organisations,
      ];
      setOrgListsArr(orgListsArr.concat(localArr));
      setChartLoader((prev) => ({ ...prev, organisationLoader: false }));
    });
  };

  const getIncomeDetail = (value, queryParams) => {
    // var pdata =
    //   value == null ? queryParams : queryParams + "&organisation_id=" + value;
    let pdata = {organisation_id:value ,from_date:queryParams?.from_date,end_date:queryParams?.end_date}
    DataService.getDirectData("dashboards/finance_incomes?", {...pdata}).then(
      (response) => {
        console.log(`new Date().getFullYear()`, response);
        setIncomeData({ ...incomeData, ...response });
        setChartLoader((prev) => ({ ...prev, incomeLoader: false }));
      }
    );
  };

  const getAssignmentByPieDuration = (value, queryParams) => {
    // var pdata =
    //   value == null ? "?filter=2023" : "?filter=2023&organisation_id=" + value;
    let pdata = {organisation_id:value }
    DataService.getDirectData(
      "dashboards/quarterly_finance_incomes",
      {...pdata}
    ).then((response) => {
      const oldData = {...assignmentPieDurationData}
      oldData.datasets[0].data = response.data.map(
        (data) => data.value
      );
      oldData.labels = response.data.map((data) => data.key);
      let isArrayZero = assignmentPieDurationData.datasets[0].data;
      let minValue = Math.min.apply(Math, isArrayZero);
      let maxValue = Math.max.apply(Math, isArrayZero);
// console.log(assignmentPieDurationData,"pie")
      setMaxVal(maxValue);
      // setIsArrayZero( assignmentPieDurationData.datasets[0].data);
      setAssignmentPieDurationData({
        // ...setAssignmentPieDurationData,
        ...oldData,
      });
      setChartLoader((prev) => ({ ...prev, pieLoader: false }));
    });
  };
  const getAssignmentByStatatics = (value, queryParams) => {
    let pdata = {organisation_id:value ,from_date:queryParams?.from_date,end_date:queryParams?.end_date}
    DataService.getDirectData(
      "dashboards/financial_statistics?",
      {...pdata}
    ).then((response) => {
      const oldData={...assignmentFinancialStatistics};
      oldData.datasets[0].label =
        response.data.dataset[0].label;
      oldData.datasets[0].data =
        response.data.dataset[0].data;
      oldData.datasets[1].label =
        response.data.dataset[1].label;
      oldData.datasets[1].data =
        response.data.dataset[1].data;
      // oldData.datasets[2].label =
      //   response.data.dataset[2].label;
      // oldData.datasets[2].data =
      //   response.data.dataset[2].data;
      oldData.labels = response.data.labels;
      let isArrayZero = oldData.datasets[0].data;
      let maxValue = Math.max.apply(Math, isArrayZero);
      setMinValStatstics(maxValue);
      setAssignmentFinancialStatistics({
       ...oldData
      });
      setChartLoader((prev) => ({ ...prev, financialLoader: false }));
    });
  };

  const getAssignmentInvoiceDate = (value,queryParams) => {
    let pdata = {organisation_id:value ,from_date:queryParams?.from_date,end_date:queryParams?.end_date}
    // var pdata =
    //   value == null ? queryParams : queryParams + "&organisation_id=" + value;
    DataService.getDirectData(
      "dashboards/invoice_to_payment_date_graph?",
      {...pdata}
    ).then((response) => {
      assignmentStatusChartData.datasets[0].label = "Days";
      assignmentStatusChartData.datasets[0].data = response.data.map(
        (data) => data.value
      );
      assignmentStatusChartData.labels = response.data.map((data) => data.key);
      console.log(`assignmentStatusChartData`, assignmentStatusChartData);
      setAssignmentStatusChartData({
        ...setAssignmentStatusChartData,
        ...assignmentStatusChartData,
      });
      setChartLoader((prev) => ({ ...prev, invoiceLoader: false }));
    });
  };
  

  const plugins = [
    {
      afterDraw: function (chart) {
        console.log(chart);
        if (chart.data.datasets[0].data.length < 1) {
          let ctx = chart.ctx;
          let width = chart.width;
          let height = chart.height;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.font = "30px Arial";
          ctx.fillText("No data to display", width / 2, height / 2);
          ctx.restore();
        }
      },
    },
  ];

  return (
    <>
      <Box
        p={2}
        style={{
          position: "sticky",
          top: isManageInfo ? "168px" : "120px",
          backgroundColor: "#fff",
          zIndex: 2,
          boxShadow: "0px - 7px 0px 7px #ffffff",
        }}
      >
        <Grid container xs={12} spacing={1}>
          <Grid item xs={8}></Grid>

          <Grid item xs={2}>
            {" "}
            <Box>
              {/* <Button
                disableElevation
                style={{
                  backgroundColor: "#077f83",
                  color: "#fff",
                  textTransform: "none",
                  // marginLeft: "-25px"
                  float: "right",
                }}
              >
                <SettingsIcon
                  style={{ marginRight: 10, fontSize: 14, cursor: "pointer" }}
                />
                Customize view
              </Button> */}
            </Box>
          </Grid>
          {/* <Grid item xs={2}>
            <Box>
              <Button
                disableElevation
                style={{
                  backgroundColor: "#EF7000",
                  color: "#fff",
                  textTransform: "none",
                  // marginLeft: "2px"
                  // float: 'right'
                }}
              >
                <GetAppIcon style={{ marginRight: 10, fontSize: 14 }} />
                Download xls
              </Button>
            </Box>
          </Grid> */}
        </Grid>
        <br />
        <Grid container direction="row" alignItems="center">
          <Grid item xs={6}>
            {console.log("orgListsArr[0]", orgListsArr[0]?.organisation_name)}
            <Autocomplete
              value={orgValue}
              onChange={organisationListHandler}
              classes={{
                input: classes.autoComplete,
                option: classes.autoComplete,
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                console.log(event, newInputValue);
                setInputValue(newInputValue);
              }}
              id="controllable-states-demo"
              options={orgListsArr}
              autoHighlight
              getOptionLabel={(option) => option.organisation_name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className={classes.customTextField}
                  inputProps={{
                    ...params.inputProps,
                    style: { fontSize: "16px" },
                  }}
                  placeholder="Organisation name"
                  style={{ fontSize: "20px" }}
                  autoFocus
                  variant="outlined"
                />
              )}
            />
            {/* <CustomSelect id="organisation" labelText="Select Organization" displayEmpty variant="outlined" itemArr={orgListsArr.map((option) => option.organisation_name)}
                            parentcall={onChangeItem}
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                getContentAnchorEl: null
                            }}
                            defaultValue={userData.organisation} /> */}
          </Grid>
          <Grid item xs={6}>
          <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
          {filterDataState[0]?.startDate ? (
                <AddCircleIcon
                  onClick={() => {
                    setFilterDataState([
                      {
                        key: "selection",
                        startDate: "",
                        endDate: "",
                      },
                    ]);
                  }}
                  fontSize="large"
                  color="error"
                  style={{
                    cursor: "pointer",
                    transform: "rotate(45deg)",
                    marginRight: "10px",
                  }}
                />
              ) : null}
            <div className={classes.datepickerPopover}>
              <Button
                aria-describedby={id}
                variant="contained"
                onClick={handleClickPicker}
              >
                {filterDataState[0]?.startDate
                  ? moment(filterDataState[0]?.startDate).format("DD/MM/YYYY")
                  : "DD/MM/YYYY"}{" "}
                -{" "}
                {filterDataState[0]?.endDate
                  ? moment(filterDataState[0]?.endDate).format("DD/MM/YYYY")
                  : "DD/MM/YYYY"}
              </Button>
              <Popover
                id={id}
                open={openPicker}
                anchorEl={anchorElPicker}
                onClose={handleClosePicker}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "center",
                }}
              >
                <DateRange
                  className={classes.datePicker}
                  editableDateInputs={true}
                  onChange={(item) => setFilterDataState([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={filterDataState}
                  startDatePlaceholder="Start date"
                  endDatePlaceholder="End date"
                  dateDisplayFormat="dd/MM/yyyy"
                />
              </Popover>
            </div>
            </div>
          </Grid>
        </Grid>
      </Box>
      <Box p={3} mt={4}>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item xs={4}>
            <Box boxShadow={4} p={3}>
              <Typography variant="subtitle1" color="secondary">
                <Box fontWeight="fontWeightBold">Acuity revenue</Box>
              </Typography>
              <Typography variant="h2">
                <Box mt={3} mb={1} fontWeight="fontWeightBold">
                  £{" "}
                  {incomeData.finance_acuity_income +
                    incomeData.finance_coach_income}
                </Box>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box boxShadow={4} p={3}>
              <Typography variant="subtitle1" color="secondary">
                <Box fontWeight="fontWeightBold">Acuity margin</Box>
              </Typography>
              <Typography variant="h2">
                <Box mt={3} mb={1} fontWeight="fontWeightBold">
                  {incomeData.finance_acuity_income
                    ? (
                        (incomeData.finance_acuity_income /
                          (incomeData.finance_acuity_income +
                            incomeData.finance_coach_income)) *
                        100
                      )?.toFixed(2)
                    : 0}{" "}
                  %
                </Box>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box boxShadow={4} p={3}>
              <Typography variant="subtitle1" color="secondary">
                <Box fontWeight="fontWeightBold">Partner cost</Box>
              </Typography>
              <Typography variant="h2">
                <Box mt={3} mb={1} fontWeight="fontWeightBold">
                  {incomeData.finance_coach_income
                    ? (
                        (incomeData.finance_coach_income /
                          (incomeData.finance_acuity_income +
                            incomeData.finance_coach_income)) *
                        100
                      ).toFixed(2)
                    : 0}{" "}
                  %
                </Box>
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "0.5rem" }}>
          <Grid item xs={6}>
            <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
              <Grid container direction="row" alignItems="center">
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    color="secondary"
                    style={{
                      height: "47px",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <Box
                      fontWeight="fontWeightBold"
                      style={{ marginLeft: "26px" }}
                    >
                      Financial statistics
                    </Box>
                  </Typography>
                </Grid>
                <Box width={1}>
                  {chartLoader.financialLoader ? (
                    <ChartLoader />
                  ) : (
                    <FinancialStatisticsGraph
                      financialStatisticsGraphData={
                        assignmentFinancialStatistics
                      }
                      options={chartConstants.lineOption}
                    />
                  )}
                </Box>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
              <Grid container direction="row" alignItems="center">
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    color="secondary"
                    style={{
                      height: "47px",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <Box
                      fontWeight="fontWeightBold"
                      style={{ marginLeft: "26px" }}
                    >
                      Days from invoice date to payment date
                    </Box>
                  </Typography>
                </Grid>
                <Box width={1}>
                  {" "}
                  {chartLoader.invoiceLoader ? (
                    <ChartLoader />
                  ) : (
                    <InvoiceDateToPaymentGraph
                      key={Math.random()}
                      id={userData.organisation}
                      invoiceDateToPaymentGraphData={assignmentStatusChartData}
                      options={chartConstants.options}
                    />
                  )}
                </Box>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "0.5rem" }}>
          <Grid item xs={6}>
            <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
              <Grid container direction="row" alignItems="center">
                <Grid item xs={12}>
                  <Grid container direction="row" alignItems="center">
                    {/* <Grid item xs={6} style={{ padding: "8px 16px" }}>
                      <CustomSelect
                        id="quater_type"
                        labelText="Select option"
                        // displayEmpty
                        variant="outlined"
                        itemArr={[
                          "Income",
                        ]}
                        parentcall={onChangeItem}
                        MenuProps={{
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                          getContentAnchorEl: null,
                        }}
                        defaultValue={userData.quater_type||"Income"}
                      />
                    </Grid> */}
                    <Grid item xs={6} style={{ textAlign: "center" }}>
                      <Typography variant="subtitle1" color="secondary">
                        <Box fontWeight="fontWeightBold">Income by quarter</Box>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Box width={1} className={classes.pieContainer}>
                  {chartLoader.pieLoader ? (
                    <ChartLoader />
                  ) : (
                    <PieGraph
                      pieGraphData={assignmentPieDurationData}
                      options={options}
                    />
                  )}
                </Box>

                {/* <Grid item xs={12} style={{ padding: maxVal === 0 ? "121px" : "0px", height: maxVal === 0 ? "340px" : "" }} >
                                        {maxVal === 0 ?
                                            <span >Data Not Found</span>
                                            :
                                            <Pie data={assignmentPieDurationData} />
                                        }
                                    </Grid> */}
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={8}></Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Finance;
//

const NotFoundFallback = () => {
  return (
    <Box
      style={{
        width: "100%",
        height: "23.5rem",
        maxHeight: "23.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        component={"p"}
        style={{ fontWeight: 800, fontSize: "1.1rem" }}
      >
        Data not found
      </Typography>
    </Box>
  );
};

const FinancialStatisticsGraph = React.memo(
  (props) => {
    const dataLength =
      props.financialStatisticsGraphData.datasets[0].data.length;
    const labelLength = props.financialStatisticsGraphData.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Line
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data={assignmentPieDurationData}
            data={props.financialStatisticsGraphData}
            // options={options}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.financialStatisticsGraphData) ===
      JSON.stringify(nextProps.financialStatisticsGraphData)
    );
  }
);

const InvoiceDateToPaymentGraph = React.memo(
  (props) => {
    console.log(props);
    const dataLength =
      props.invoiceDateToPaymentGraphData.datasets[0].data.length;
    const labelLength = props.invoiceDateToPaymentGraphData.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data={assignmentPieDurationData}
            data={props.invoiceDateToPaymentGraphData}
            // options={options}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.invoiceDateToPaymentGraphData) ===
      JSON.stringify(nextProps.invoiceDateToPaymentGraphData)
    );
  }
);

const PieGraph = React.memo(
  (props) => {
    const dataLength = props.pieGraphData.datasets[0].data.length;
    const labelLength = props.pieGraphData.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Pie
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data={assignmentPieDurationData}
            data={props.pieGraphData}
            // options={options}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.pieGraphData) ===
      JSON.stringify(nextProps.pieGraphData)
    );
  }
);
